import { apiSlice } from "../../api-slice";
import { CreateAccountForm, UpdateUserAccountInfo } from "./account-api-request";
import { AccountResponse, ReportingHead, ReportingHeadResponse, UserInformation, UserListResponse } from "./account-api-state";

export const accountAPI = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getUserList: builder.query<UserInformation[], void>({
            query: () => `/api/user`,
            transformResponse: (response: UserListResponse) => response.data,
            transformErrorResponse: (response: any) => response,
            providesTags: [{ type: 'User', id: 'LIST' }],
        }),
        createNewUser: builder.mutation<AccountResponse, CreateAccountForm>({
            query: (body) => ({
                url: '/api/user/register',
                method: 'POST',
                body,
            }),
            transformErrorResponse: (response: any) => response.data,
            invalidatesTags: [{ type: 'User', id: 'LIST' }],
        }),
        resetPasswordUser: builder.mutation<AccountResponse, {userId: number}>({
            query: ({userId}) => ({
                url: `/api/user/admin/reset-password/${userId}`,
                method: 'POST',
            }),
            transformErrorResponse: (response: any) => response.data,
            invalidatesTags: (result, error, { userId }) => [
                { type: "User", id: userId },
                { type: 'User', id: 'LIST' },
            ],
        }),
        deactivateUser: builder.mutation<AccountResponse, { userId: number; action: "activate" | "deactivate" }>({
            query: ({ userId, action }) => ({
                url: `/api/user/${action}/${userId}`,
                method: 'PUT',
            }),
            transformErrorResponse: (response: any) => response.data,
            invalidatesTags: (result, error, { userId }) => [
                { type: "User", id: userId },
                { type: 'User', id: 'LIST' },
            ],
        }),
        updateUserAccountInfo: builder.mutation<AccountResponse, { userId: number, body: UpdateUserAccountInfo }>({
            query: ({ userId, body }) => ({
                url: `/api/user/admin/update-user/${userId}`,
                method: 'PUT',
                body,
            }),
            transformErrorResponse: (response: any) => response.data,
            invalidatesTags: (result, error, { userId }) => [
                { type: "User", id: userId },
                { type: 'User', id: 'LIST' },
            ],
        }),
        getReportingHead: builder.query<ReportingHead[], void>({
            query: () => `api/user/potential-superiors`,
            transformResponse: (response: ReportingHeadResponse) => response.data,
            transformErrorResponse: (response: any) => response,
            providesTags: [{ type: 'AcctReportHead', id: 'LIST' }]
        }),
    })
})

export const {
    useCreateNewUserMutation,
    useGetUserListQuery,
    useLazyGetUserListQuery,
    useResetPasswordUserMutation,
    useDeactivateUserMutation,
    useUpdateUserAccountInfoMutation,
    useGetReportingHeadQuery,
} = accountAPI  